import React from 'react';

import { breakpoints, css, dimensions, respondTo, styled } from '~/styles';

const StyledPageRootContainer = styled.div`
  display: flex;
  flex-flow: column;  
  min-height: 100vh;
  overflow: hidden;

  main {
    flex-grow: 1;
    flex-basis: 100%;
    display: flex;
    flex-flow: column;
    align-items: stretch;

      // header
    padding-top: ${dimensions.headerHeight.desktop}px;

    ${respondTo(breakpoints.md, css`
      padding-top: ${dimensions.headerHeight.mobile}px;
      padding-bottom: 0;
    `)};
  }

`

interface Props {}
const PageRootContainer: React.FC<Props> = ({ children }) => (
  <StyledPageRootContainer>
    { children }
  </StyledPageRootContainer>
)
export default PageRootContainer;



// WEBPACK FOOTER //
// ./src/components/layout/PageRootContainer.tsx